import * as actionsType from "./actionsType";

export const changeOtzstatus = (payload) => {
  return {
    type: actionsType.CHANGE_OTZ_STATUS,
    payload: payload,
  };
};
